<template>
	<div v-show="fieldList.length" class="custom-detail flex-wrap">
		<c-detail-item v-for="(item, i) in fieldList" :key="i" :label="item.field_title" :colspan="i == fieldList.length - 1 ? lastColspan : 1" :tip="item.config_json.tip">
			<div v-if="['image', 'file'].includes(item.config_json.type)" class="flex-wrap file-list">
				<template v-if="data[item.field_code]">
					<template v-if="typeof data[item.field_code] == 'string'">
						<c-file v-for="(file, i) in data[item.field_code].split(',')" :key="i" :src="file" media :preview="data[item.field_code].split(',')"></c-file>
					</template>
					<template v-else>
						<c-file v-for="(file, i) in data[item.field_code]" :key="i" :src="file" media :preview="data[item.field_code]"></c-file>
					</template>
				</template>
			</div>
			<c-tags v-else-if="typeof data[item.field_code] == 'object'" :value="data[item.field_code]"></c-tags>
			<template v-else>
				{{data[item.field_code] || '-'}}
			</template>
		</c-detail-item>
	</div>
</template>

<script>
	export default {
		name: 'customDetail',

		props: {
			workType: [String, Number],
			data: Object
		},

		data() {
			return {
				fieldList: []
			}
		},

		computed: {
			lastColspan() {
				return this.fieldList.length % 3 || 1;
			}
		},

		methods: {
			init() {
				this.request({
					url: '/sys_field/list',
					data: {
						work_type_id: this.workType
					},
					success: data => {
						this.fieldList = data;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.custom-detail {
		width: 100%;

		.file-list {
			gap: 6px;

			>>> .c-file-media {
				width: 50px;
				height: 50px;
			}
		}
	}
</style>
